export default {
  default: () => import("/var/www/mj_client/releases/20251106060921/layouts/default.vue").then(m => m.default || m),
  simple: () => import("/var/www/mj_client/releases/20251106060921/layouts/simple.vue").then(m => m.default || m)
}